import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

// Registrar locale español (calendario empieza en lunes)
registerLocale('es', es);

/**
 * Componente DateInput reutilizable
 * - Formato dd-MM-yyyy
 * - Calendario empieza en lunes
 * - Locale español
 */
function DateInput({ value, onChange, className, style, placeholder }) {
  // Convertir string yyyy-mm-dd a Date object
  const dateValue = value ? new Date(value + 'T00:00:00') : null;

  const handleChange = (date) => {
    if (date) {
      // Convertir Date a string yyyy-mm-dd para mantener compatibilidad con los filtros
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      onChange(`${year}-${month}-${day}`);
    } else {
      onChange('');
    }
  };

  // Formatear días de la semana como L M X J V S D
  const formatWeekDay = (dayName) => {
    // dayName recibe el nombre completo del día (ej: "lunes", "martes", etc.)
    const firstLetter = String(dayName).charAt(0).toUpperCase();
    return firstLetter;
  };

  return (
    <DatePicker
      selected={dateValue}
      onChange={handleChange}
      dateFormat="dd-MM-yyyy"
      locale="es"
      calendarStartDay={1}
      formatWeekDay={formatWeekDay}
      className={className || 'form-control'}
      placeholderText={placeholder || 'dd-mm-aaaa'}
      isClearable
      showPopperArrow={false}
      popperClassName="datepicker-popper"
      popperPlacement="bottom-start"
      autoComplete="off"
      wrapperClassName="date-input-wrapper"
      withPortal
      portalId="root-portal"
    />
  );
}

export default DateInput;
